type Key = "is-logged-in";

const get = (key: Key) => localStorage.getItem(key);
const del = (key: Key) => localStorage.removeItem(key);
const set = (key: Key, value: string) => localStorage.setItem(key, value);

const LocalStorage = { get, del, set };

export default LocalStorage;
